// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"QnAWrapper_modal-scroll__z4tsA","container":"QnAWrapper_container__8NnYk"};